import { getMediaDevices } from '@gem/call/Removable/packages/deviceInfo/deviceInfo';
import { t } from '@gem/modules/i18n';
import { popupsTasks } from '@gem/popups';

export const hasMicrophone = async (): Promise<boolean> => {
  const { hasMicrophone } = await getMediaDevices();

  if (!hasMicrophone) {
    popupsTasks.showAlert(t('calls_no_microphone_connected'));

    return false;
  }

  return true;
};
